import React, { useEffect } from 'react';
import { Phone, Mail, ChevronRight, MapPin } from 'lucide-react';
export function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-31">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-33">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-34">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-35">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-36" />
            <span className="text-charcoal font-medium" data-id="element-37">About Us</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-38">
            About Switchplate Gallery
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-39">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-40">
          {/* Main Content */}
          <div className="lg:w-2/3" data-id="element-41">
            {/* Hero Image */}
            <div className="bg-white p-3 rounded-sm shadow-sm border border-warmBorder mb-10" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/jVN2C6mLSrCws4AKbsFcsd/image.png" alt="Switchplate Gallery home and workshop in rural Cameron, West Virginia" className="w-full h-auto rounded-sm" data-id="element-43" />
              <p className="text-sm text-warmGray italic mt-3 px-2 pb-1" data-id="element-44">
                Our home and workshop in Cameron, West Virginia
              </p>
            </div>

            {/* Our Story */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder mb-8" data-id="element-45">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-46">
                Our Story
              </h2>
              <div className="space-y-5 text-warmGray leading-relaxed text-base md:text-lg" data-id="element-47">
                <p data-id="element-48">
                  Three miles back a dirt road, through the forest across the
                  creek and over the farm fields, in rural West Virginia, is the
                  home of{' '}
                  <strong className="text-charcoal font-bold" data-id="element-49">
                    Switchplate Gallery
                  </strong>
                  . Family members, neighbors and friends work together in our
                  little cottage industry to bring you our charming collection
                  of switchplates.
                </p>
                <p data-id="element-50">
                  <strong className="text-charcoal font-bold" data-id="element-51">
                    Switchplate Gallery
                  </strong>{' '}
                  has the largest assortment of popular designs to be found! We
                  also make nearly every plate configuration that might be
                  needed. We are proud and satisfied to provide a very appealing
                  quality product that customers across the country are
                  delighted to have in their homes.
                </p>
              </div>
            </div>

            {/* How We Make Our Switchplates */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder mb-8" data-id="element-52">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-53">
                How We Make Our Switchplates
              </h2>
              <div className="space-y-5 text-warmGray leading-relaxed text-base md:text-lg" data-id="element-54">
                <p data-id="element-55">
                  Each switchplate is carefully made by hand using a découpage
                  technique. Art prints, which have been cropped to size, are
                  mounted on each durable steel plate by hand with waterproof
                  adhesive. Each finished plate must be free of creases,
                  bubbles, lumps or tears!
                </p>
                <p data-id="element-56">
                  To insure quality workmanship, each plate is closely inspected
                  before receiving several coats of acrylic sealer. We have also
                  filled some screw holes and use only as many screws as are
                  necessary to hold the switchplate securely. Finally, each
                  screw is hand-painted to match the background of the
                  switchplate and is included in the package. All materials used
                  are made in the USA.
                </p>
                <p data-id="element-57">
                  <strong className="text-charcoal font-bold" data-id="element-58">
                    Switchplate Gallery
                  </strong>{' '}
                  is pleased to create a product that gives such pleasure!
                </p>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="bg-charcoal text-cream p-8 md:p-10 rounded-sm" data-id="element-59">
              <h3 className="text-2xl font-serif text-white mb-3" data-id="element-60">
                Get in Touch
              </h3>
              <p className="text-warmGray-light leading-relaxed mb-6" data-id="element-61">
                We'd love to hear from you — whether you have a question about
                our products, need help with sizing, or want to place a custom
                order.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-62">
                <a href="tel:8004976946" className="inline-flex items-center gap-2 px-6 py-3 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm" data-id="element-63">
                  <Phone size={16} data-id="element-64" />
                  800.497.6946
                </a>
                <a href="mailto:switchplategallery@msn.com" className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 border border-white/20 text-white hover:bg-white/20 font-bold rounded-sm transition-colors text-sm" data-id="element-65">
                  <Mail size={16} data-id="element-66" />
                  switchplategallery@msn.com
                </a>
              </div>
              <p className="text-warmGray-light text-sm mt-4" data-id="element-67">
                Available 9AM–5PM EST
              </p>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-68">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-69">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-70">
                Visit Us
              </h4>

              <div className="space-y-4 text-sm mb-8" data-id="element-71">
                <div className="flex items-start gap-3" data-id="element-72">
                  <MapPin className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" data-id="element-73" />
                  <span className="text-warmGray leading-relaxed" data-id="element-74">
                    44 Grannys Lookout Loop
                    <br data-id="element-75" />
                    Cameron, WV 26033
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-76">
                  <Phone className="h-5 w-5 text-gold flex-shrink-0" data-id="element-77" />
                  <div className="text-warmGray" data-id="element-78">
                    <a href="tel:3046863170" className="hover:text-gold transition-colors" data-id="element-79">
                      304.686.3170
                    </a>
                    <span className="mx-1.5 text-warmBorder" data-id="element-80">|</span>
                    <a href="tel:8004976946" className="hover:text-gold transition-colors font-bold text-charcoal" data-id="element-81">
                      800.497.6946
                    </a>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-82">
                  <Mail className="h-5 w-5 text-gold flex-shrink-0" data-id="element-83" />
                  <a href="mailto:switchplategallery@msn.com" className="text-warmGray hover:text-gold transition-colors" data-id="element-84">
                    switchplategallery@msn.com
                  </a>
                </div>
              </div>

              <div className="border-t border-warmBorder pt-6" data-id="element-85">
                <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-86">
                  Helpful Links
                </h4>
                <ul className="space-y-4" data-id="element-87">
                  <li data-id="element-88">
                    <a href="#/about" className="flex items-center text-gold font-medium group" data-id="element-89">
                      <span className="w-2 h-2 rounded-full bg-gold mr-3" data-id="element-90" />
                      About Us
                    </a>
                  </li>
                  <li data-id="element-91">
                    <a href="#/custom-orders" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-92">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-93" />
                      Custom &amp; Special Orders
                    </a>
                  </li>
                  <li data-id="element-94">
                    <a href="#/size-chart" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-95">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-96" />
                      Size Chart
                    </a>
                  </li>
                  <li data-id="element-97">
                    <a href="#/faq" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-98">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-99" />
                      FAQ &amp; "How To" Info
                    </a>
                  </li>
                  <li data-id="element-100">
                    <a href="#/contact" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-101">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-102" />
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}